import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = () => {
  return (
    <section className="w-full py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto space-y-8">
          <div className="text-center space-y-4 mb-12">
            <h2 className="text-3xl font-bold text-[#174996]">Frequently Asked Questions</h2>
            <p className="text-lg text-muted-foreground">
              Get answers to common questions about hiring contractors in Oklahoma City
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            <AccordionItem value="item-1" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                How do I know if a contractor is reliable and trustworthy?
              </AccordionTrigger>
              <AccordionContent>
                We recommend starting with your own research: check their reviews, past work examples, and references. Look for contractors with consistent positive feedback, clear communication, and a history of completed projects in your area. It's important to verify their business credentials and insurance coverage independently before hiring.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                What questions should I ask before hiring a contractor?
              </AccordionTrigger>
              <AccordionContent>
                Here are key questions to ask: How long have you been in business? Can you provide local references? Do you have insurance coverage? Will you pull necessary permits? Can you provide a detailed written estimate? What's the project timeline? How do you handle unexpected issues? What's your payment schedule? Getting clear answers to these questions helps ensure a smoother project experience.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                How much should I expect to pay upfront?
              </AccordionTrigger>
              <AccordionContent>
                A reasonable down payment is typically 10-30% of the total project cost. Be cautious of contractors asking for more than 30% upfront. The exact amount can vary based on project size and material costs. Always get the payment schedule in writing, and never pay the full amount before the work is completed and you're satisfied with the results.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                What if something goes wrong during or after the project?
              </AccordionTrigger>
              <AccordionContent>
                Make sure you have a written contract that includes a warranty or guarantee period. If issues arise, document everything with photos and written communication. Consider working with contractors who have a track record of resolving issues professionally. If needed, consult with local consumer protection agencies or legal professionals for guidance.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                How long should I expect my home improvement project to take?
              </AccordionTrigger>
              <AccordionContent>
                Project timelines vary significantly based on scope and complexity. Small repairs might take a few hours, while major renovations could span several weeks or months. Weather, material availability, and permit processing can all impact timing. Ask potential contractors to provide a realistic timeline and keep you updated on progress. Remember, quality work takes time - it's better to do it right than to rush.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6" className="border rounded-lg px-4">
              <AccordionTrigger className="text-left">
                Do I need permits for my home improvement project?
              </AccordionTrigger>
              <AccordionContent>
                In Oklahoma City, many home improvement projects require permits, especially those involving structural changes, electrical work, plumbing, or HVAC systems. Your contractor should know local requirements and handle permit applications. Working without required permits can lead to fines, complications during home sale, or safety issues. When in doubt, check with the city's building department.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
};